import OriginTracing from '@atlassiansox/origin-tracing';
import { Environment, Url } from '@atlassiansox/bxpkit-core';

type SwitchAccountUrlType = {
  readonly signInAccountOrigin: OriginTracing;
  readonly switchAccountOrigin: OriginTracing;
  readonly signInAccountUrl: string;
  readonly switchAccountUrl: string;
};

export const accountOperationUrl = (): SwitchAccountUrlType => {
  const queryParameters = Url.getUrlParams() || {};

  const signInAccountOrigin = new OriginTracing({
    product: 'wac-signup-login'
  });
  const switchAccountOrigin = new OriginTracing({
    product: 'wac-signup-switch'
  });

  const signInAccountUrl = Environment.getIdSigninUrl(
    signInAccountOrigin.encode(),
    undefined,
    queryParameters['continue']
  );
  const switchAccountUrl = Environment.getIdSwitchUserUrl(
    switchAccountOrigin.encode()
  );

  return {
    signInAccountOrigin,
    switchAccountOrigin,
    signInAccountUrl,
    switchAccountUrl
  };
};
